var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3654 0H17.967L12.5529 5.75396C10.5922 7.8366 7.4134 7.8366 5.45133 5.75396L0.0351562 0H2.63883L6.75211 4.37094C7.35141 5.00495 8.15907 5.36035 9.00053 5.36035C9.84198 5.36035 10.6496 5.00495 11.2489 4.37094L15.3654 0Z",
    fill: "#23292F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60332 15.9999H0L5.44922 10.2104C7.40988 8.12778 10.5887 8.12778 12.5508 10.2104L18 15.9999H15.3984L11.25 11.5934C10.6507 10.9594 9.84304 10.604 9.00158 10.604C8.16013 10.604 7.35247 10.9594 6.75316 11.5934L2.60332 15.9999Z",
    fill: "#23292F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/_xrp.3d67f3d4c727fcebcbfbced2ba64b84f.svg";
export { ForwardRef as ReactComponent };